export default __webpack_public_path__ + "static/media/Capture.96ce9559.JPG";